import React from "react"
import Header from "../components/Header"
import AccountGrid from "../components/AccountGrid"

const Accounts = () => {
    return (
        <Header title="Accounts">
            <AccountGrid />
        </Header>
    )
}

export default Accounts
